export type ChannelType = 'telegram' | 'slack' | 'whatsapp';
export type ChannelStatus = 'disconnected' | 'connected' | 'connecting' | 'error';

export interface ChannelConfig {
  id: number;
  channel_type: ChannelType;
  display_name: string;
  credentials: string;
  status: ChannelStatus;
  last_connected_at: string | null;
  error_message: string | null;
  external_user_id: string | null;
  company_id: number | null;
  agent_id: number | null;
  user_id: number | null;
  created_at: string;
  updated_at: string;
}

export interface CreateChannelConfigRequest {
  channel_type: ChannelType;
  display_name: string;
  credentials: string;
  company_id?: number;
  agent_id?: number;
}

export interface UpdateChannelConfigRequest {
  display_name?: string;
  credentials?: string;
}

export interface TestChannelResponse {
  success: boolean;
  status?: ChannelStatus;
  message?: string;
}

export type MessageDirection = 'inbound' | 'outbound';

export interface Message {
  id: number;
  channel_config_id: number;
  direction: MessageDirection;
  content: string;
  sender_id: string | null;
  metadata: string | null;
  user_id: number | null;
  created_at: string;
}

export interface MessagesResponse {
  messages: Message[];
  total: number;
  limit: number;
  offset: number;
}

export interface ChannelMeta {
  type: ChannelType;
  label: string;
  icon: string;
  credentialLabel: string;
  credentialPlaceholder: string;
  credentialHint: string;
  usesQrCode: boolean;
}

export const CHANNEL_META: Record<ChannelType, ChannelMeta> = {
  telegram: {
    type: 'telegram',
    label: 'Telegram',
    icon: '💬',
    credentialLabel: 'Bot Token',
    credentialPlaceholder: '123456:ABC-DEF...',
    credentialHint: 'Erstelle einen Bot via @BotFather und kopiere den Token.',
    usesQrCode: false,
  },
  slack: {
    type: 'slack',
    label: 'Slack',
    icon: '📱',
    credentialLabel: 'Bot & App Token (JSON)',
    credentialPlaceholder: '{"botToken": "xoxb-...", "appToken": "xapp-..."}',
    credentialHint: 'Erstelle eine Slack App mit Socket Mode und kopiere beide Tokens.',
    usesQrCode: false,
  },
  whatsapp: {
    type: 'whatsapp',
    label: 'WhatsApp',
    icon: '📞',
    credentialLabel: 'Session ID',
    credentialPlaceholder: 'default',
    credentialHint: 'Nach dem Verbinden wird ein QR-Code zum Scannen angezeigt.',
    usesQrCode: true,
  },
};
